<template>
  <div class="button-box">
    <v-icon @click.stop="$emit('input', true)" v-if="isHovering && !value">mdi-pencil</v-icon>
    <div class="hvh-flex" v-if="value">
      <v-icon class="clickable" @click="$emit('input', false)">mdi-close-circle</v-icon>
      <v-icon class="clickable" @click="$emit('save')">mdi-check-circle</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  export: false,
  props: ['value', 'isHovering'],
};
</script>

<style lang="scss" scoped>
.button-box {
  position: absolute;
  top: 0;
  right: 0;
}
</style>